import { createWebEnvironment } from './relay-environment-common';

const environment = createWebEnvironment();
export default environment;
